import { IntlShape } from "react-intl";
import { TonesetText } from "../../../../../../common/types";
import messages from "./messages";

export const textOptions = ({ formatMessage }: IntlShape) => [
    {
        label: formatMessage(messages.solfa),
        value: TonesetText.Solfa,
    },
    {
        label: formatMessage(messages.abc),
        value: TonesetText.Abc,
    },
    {
        label: formatMessage(messages.empty),
        value: TonesetText.Empty,
    },
    {
        label: formatMessage(messages.handsign),
        value: TonesetText.Handsign,
    },
];
